import React from 'react'
import PropTypes from 'prop-types'
import { FileText as FileTextIcon } from 'react-feather'
import { Box, Paper, Typography } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

import { JoditEditor } from 'components'

import useFetch from 'hooks/useFetch'

import theme from 'theme'
import useStyles from './styles'
import * as service from 'service'

const DocumentPreview = ({ privacyPolicyId }) => {
  const classes = useStyles()

  // O conteúdo não vem no payload da atividade justamente para não carregá-lo com o corpo de vários
  // documentos — é buscado aqui, só do documento que o usuário escolheu visualizar.
  const { response, isLoading } = useFetch(
    service.dponet.privacyPolicies.get,
    { privacyPolicyId },
    [privacyPolicyId],
    !!privacyPolicyId,
  )

  const privacyPolicy = response?.data?.privacyPolicy

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Pré-visualização
      </Typography>
      <Paper variant="outlined" className={classes.previewPaper}>
        {!privacyPolicyId ? (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gridGap={theme.spacing(1)}
            px={2}
            py={5}
          >
            <FileTextIcon size={28} color={theme.palette.text.secondary} />
            <Typography variant="body2" color="textSecondary" align="center">
              Selecione &quot;Visualizar&quot; em um dos documentos para ler o
              conteúdo.
            </Typography>
          </Box>
        ) : (
          <Box className={classes.previewBoxContainer}>
            <Box padding={1.5} className={classes.previewBox}>
              {isLoading ? (
                <Box
                  display="flex"
                  flexDirection="column"
                  gridGap={theme.spacing(1)}
                >
                  <Skeleton variant="text" width="60%" height={28} />
                  {Array.from({ length: 8 }, (_, index) => (
                    <Skeleton key={index} variant="text" />
                  ))}
                </Box>
              ) : (
                <JoditEditor.Preview
                  allowIframe
                  content={privacyPolicy?.content}
                />
              )}
            </Box>
          </Box>
        )}
      </Paper>
    </Box>
  )
}

DocumentPreview.propTypes = {
  privacyPolicyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default DocumentPreview
